import React, { useEffect, useRef, useState } from "react";
import DashboardMob from "../../assets/svg/dash-logo.svg";
import LogoutImg from "../../assets/svg/logout.svg";
import SupportImg from "../../assets/svg/support.svg";
import TermImg from "../../assets/svg/t&c.svg";
import HospicashImg from "../../assets/svg/hospicash-unselect.svg";
import WellnessImg from "../../assets/svg/wellness-unselect.svg";
import ComprehensiveImg from "../../assets/svg/comprehensive-unselect.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CloseImg from "../../assets/svg/close.svg";
import "./style.scss";
import { Modal } from "../../components/Modal";
import PrimaryButton from "../../components/Button/PrimaryButton";
import TextInput from "../../components/TextInput";
import { useFormik } from "formik";
import { validationSchemaSupport } from "../../utils/validation/customerFormValidation";
import ROUTE_PATH from "../../constant/route";
import { useLocation, useNavigate } from "react-router-dom";
import { InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/store";
import { handleSupport } from "../../store/reducers/support/apiThunk";
// import ReCAPTCHA from "react-google-recaptcha";
import { handleCustomerDetail } from "../../store/reducers/authentication/apiThunk";
import { updateUserData } from "../../store/reducers/authentication";
import { showToast } from "../../components/Toast";
import VideoModal from "../../pages/Login/VideoModal";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";

interface LayoutProps {
  children: React.ReactNode;
}
const DashboardLayout: React.FC<LayoutProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const reduxDetail = useSelector((state: any) => state?.authentication);
  const {
    login: { mobileNo = "" },
  } = reduxDetail;
  // const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const currentUrl = window.location.href;
  const isCoversure = currentUrl.includes("https://users.coversure.in");
  const websiteUrl = isCoversure
    ? "https://www.coversure.in/"
    : "https://www.coversure.click/";
  const [openLogout, setOpenLogout] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const [openTerm, setOpenTerm] = useState(false);
  const [userDetail, setUserDetail] = useState<any>({});
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const [link, setLink] = useState("");
  function handleChange() {
    setOpen(!isOpen);
  }
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      query: "",
      company: "",
      phoneNumber: "",
      captchaResponse: null,
    },
    validationSchema: validationSchemaSupport,
    onSubmit: async (values: any) => {
      const data = {
        fullName: values?.name,
        email: values?.email,
        message: values?.query,
        company: values?.company,
        phoneNumber: values?.phoneNumber,
        captchaResponse: values?.captchaResponse,
        source: "Partner",
        partnerName: "Prosure",
      };
      console.log(values);
      const response: any = await dispatch(handleSupport(data));
      if (response?.payload?.status === 1) {
        setOpenSupport(false);
        showToast("Message sent successfully", "success");
      } else {
        showToast("Something went wrong", "error");
      }
    },
  });
  const handleUserDetail = async () => {
    const mob = {
      mobileNo: mobileNo,
    };

    try {
      const resCustomer = await dispatch(handleCustomerDetail(mob)).unwrap();
      if (resCustomer?.status === 1) {
        setUserDetail(resCustomer?.data?.customerDetails[0]);
        dispatch(updateUserData(resCustomer?.data?.customerDetails));
        formik.setValues({
          name:
            `${resCustomer?.data?.customerDetails[0]?.firstName} ${resCustomer?.data?.customerDetails[0]?.lastName}` ||
            "",
          email: `${resCustomer?.data?.customerDetails[0]?.email}` || "",
          query: "",
          company: "",
          phoneNumber:
            `${resCustomer?.data?.customerDetails[0]?.mobileNo}` || "",
          captchaResponse: null,
        });
      }
    } catch (error) {
      showToast("Something went wrong", "error");
      console.error("Error saving user data:", error);
    }
  };

  useEffect(() => {
    handleUserDetail();
  }, []);
  const handleClickOpenLogout = () => {
    setOpenLogout(true);
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
  };

  const handleClickOpenSupport = () => {
    formik.setValues({
      name: `${userDetail?.firstName} ${userDetail?.lastName}` || "",
      email: `${userDetail?.email}` || "",
      query: "",
      company: "",
      phoneNumber: `${userDetail?.mobileNo}` || "",
      captchaResponse: null,
    });
    setOpenSupport(true);
  };
  const handleCloseSupport = () => {
    formik.resetForm();
    setOpenSupport(false);
  };

  const handleClickOpenTerm = () => {
    setOpenTerm(true);
  };
  const handleCloseTerm = () => {
    setOpenTerm(false);
  };

  const siteKey = "6Lcq1P0lAAAAADdADCc-QBpBn-Z-pNrRp_hiWMrC";
  return (
    <div className="sm:bg-bg-color-8 bg-white w-[100%]">
      <div className="block sm:flex">
        <div className="xl:w-[40%] lg:w-[47%] sm:w-[50%] hidden sm:block">
          <div className="dashboard-pattern">
            <div>
              <img
                src={DashboardMob}
                alt="DashboardMob"
                className="sm:w-[250px] lg:w-[350px] xl:w-[80%]"
              />
              <div className="lg:text-[16px] text-[14px] text-white mt-[70px] leading-[21px]">
                Hey,
              </div>
              <div className="lg:text-[32px] text-[26px] text-white lg:leading-[42px] leading-[30px] font-bold">
                {userDetail?.firstName
                  ? userDetail?.firstName + " " + userDetail?.lastName
                  : ""}
              </div>
              <div className="lg:text-[16px] text-[14px] text-white mt-[70px] leading-[21px] mb-[20px]">
                Your Subscription
              </div>
              <div>
                {/* <div
                  className="flex items-center justify-between bg-white p-[6px] rounded-[14px] mb-[12px] cursor-pointer"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(ROUTE_PATH.HOSPICASH);
                  }}
                  style={
                    location.pathname.includes(ROUTE_PATH.HOSPICASH)
                      ? { backgroundColor: "#ffff" }
                      : { backgroundColor: "#3F6EFB" }
                  }
                >
                  <div
                    className="flex items-center text-[16px] leading-[18px] font-semibold"
                    style={
                      location.pathname.includes(ROUTE_PATH.HOSPICASH)
                        ? { color: "#1E56FF" }
                        : { color: "white" }
                    }
                  >
                    <div className="shadow-custom-light mr-[5px] bg-bg-color-6 rounded-[8px]">
                      {" "}
                      <img src={HospicashImg} alt="HospicashImg" />
                    </div>
                    Hospicash Insurance
                  </div>
                  <KeyboardArrowRightIcon
                    style={
                      location.pathname.includes(ROUTE_PATH.HOSPICASH)
                        ? { color: "#1E56FF" }
                        : { color: "#ffff" }
                    }
                  />
                </div> */}
                <div
                  className="flex items-center justify-between bg-bg-color-7 p-[6px] rounded-[14px] mb-[12px] cursor-pointer"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(ROUTE_PATH.WELLNESS);
                  }}
                  style={
                    location.pathname.includes(ROUTE_PATH.WELLNESS)
                      ? { backgroundColor: "#ffff" }
                      : { backgroundColor: "#3F6EFB" }
                  }
                >
                  <div
                    className="flex items-center text-[16px] leading-[18px] font-semibold"
                    style={
                      location.pathname.includes(ROUTE_PATH.WELLNESS)
                        ? { color: "#1E56FF" }
                        : { color: "white" }
                    }
                  >
                    <div className="shadow-custom-light mr-[5px] bg-bg-color-6 rounded-[8px]">
                      {" "}
                      <img src={WellnessImg} alt="WellnessImg" />
                    </div>
                    Wellness Benefits
                  </div>
                  <KeyboardArrowRightIcon
                    style={
                      location.pathname.includes(ROUTE_PATH.WELLNESS)
                        ? { color: "#1E56FF" }
                        : { color: "#ffff" }
                    }
                  />
                </div>
                {/* <div
                  className="flex items-center justify-between bg-bg-color-7 p-[6px] rounded-[14px] mb-[12px] cursor-pointer"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(ROUTE_PATH.COMPREHENSIVE);
                  }}
                  style={
                    location.pathname.includes(ROUTE_PATH.COMPREHENSIVE)
                      ? { backgroundColor: "#ffff" }
                      : { backgroundColor: "#3F6EFB" }
                  }
                >
                  <div
                    className="flex items-center text-white text-[16px] leading-[18px] font-semibold"
                    style={
                      location.pathname.includes(ROUTE_PATH.COMPREHENSIVE)
                        ? { color: "#1E56FF" }
                        : { color: "white" }
                    }
                  >
                    <div className="shadow-custom-light mr-[5px] bg-bg-color-6 rounded-[8px]">
                      {" "}
                      <img src={ComprehensiveImg} alt="ComprehensiveImg" />
                    </div>
                    Coversure Platform
                  </div>
                  <KeyboardArrowRightIcon
                    style={
                      location.pathname.includes(ROUTE_PATH.COMPREHENSIVE)
                        ? { color: "#1E56FF" }
                        : { color: "#ffff" }
                    }
                  />
                </div> */}
              </div>
            </div>
            <div>
              <div className="flex w-[100%] mt-[150px]">
                <div className="w-[50%] flex flex-col justify-center items-end mr-[10px]">
                  <div
                    className="w-fit cursor-pointer"
                    onClick={() => {
                      setLink("https://www.youtube.com/watch?v=kJVSGNRp29w");
                      handleChange();
                    }}
                  >
                    <div className="mt-[12px] w-[100%] text-center">
                      <PlayCircleFilledWhiteOutlinedIcon
                        style={{
                          color: "#ffff",
                          marginRight: "10px",
                        }}
                      />
                      <span className="text-bg-color-3 underline text-[13px] lg:text-[16px]">
                        See how it works
                      </span>
                    </div>
                  </div>
                </div>
                <div className="w-[50%] flex flex-col justify-center items-start ml-[10px] ">
                  <div
                    className="w-fit cursor-pointer"
                    onClick={() => {
                      setLink("https://www.youtube.com/watch?v=N9UAo7ZF3jo");
                      handleChange();
                    }}
                  >
                    <div className="mt-[12px] w-[100%] text-center">
                      <PlayCircleFilledWhiteOutlinedIcon
                        style={{
                          color: "#ffff",
                          marginRight: "10px",
                        }}
                      />
                      <span className="text-bg-color-3 underline text-[13px] lg:text-[16px]">
                        कैसे उपयोग करे
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between mt-[40px]">
                <div
                  className="bg-bg-color-5 flex items-center w-fit rounded-[12px] py-[10px] lg:px-[22px] px-[18px] lg:text-[18px] text-[14px] leading-[18px] font-medium text-white cursor-pointer"
                  onClick={handleClickOpenLogout}
                >
                  <img src={LogoutImg} alt="LogoutImg" className="mr-[5px]" />
                  Logout
                </div>
                <div
                  className="bg-bg-color-5 flex items-center w-fit rounded-[12px] py-[10px] lg:px-[22px] px-[18px] lg:text-[18px] text-[14px] leading-[18px] font-medium text-white cursor-pointer"
                  onClick={() => {
                    formik.resetForm();
                    handleClickOpenSupport();
                  }}
                >
                  <img src={SupportImg} alt="SupportImg" className="mr-[5px]" />
                  Support
                </div>
                <div
                  className="bg-bg-color-5 flex items-center w-fit rounded-[12px] py-[10px] lg:px-[22px] px-[18px] lg:text-[18px] text-[14px] leading-[18px] font-medium text-white cursor-pointer"
                  onClick={() => {
                    window.open(
                      `${websiteUrl}prosure`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  <img src={TermImg} alt="TermImg" className="mr-[5px]" />
                  T&C
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Main Content */}
        <div className="xl:w-[60%] sm:w-[50%] lg:w-[53%] w-[100%] h-[100%]">
          <main className="flex-grow w-[100%]">{children}</main>
        </div>
      </div>
      <Modal
        open={openLogout}
        handleClose={handleCloseLogout}
        content={
          <div className="max-w-[570px] max-h-[321px] p-[20px] sm:p-[60px] flex flex-col items-center justify-center">
            <div className="text-[25px] leading-[28px] sm:text-[31px] sm:leading-[31px] font-semibold font-poppins">
              Are you sure?
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-medium text-text-color-3 text-center pt-[16px] font-poppins">
              You’re about to log out. Make sure to save any changes before you
              go.
            </div>
            <div className="block sm:flex items-center justify-between w-[100%]">
              <PrimaryButton
                label={
                  <div className="flex items-center justify-center w-[100%] font-black">
                    <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] text-text-color-3">
                      Cancel
                    </div>
                  </div>
                }
                onClick={handleCloseLogout}
                classname="w-[100%] sm:w-[40%] mx-auto mt-[20px] lg:mt-[40px]"
                style={{ backgroundColor: "#E5E5E5" }}
              />
              <PrimaryButton
                label={
                  <div className="flex items-center justify-center w-[100%] font-black">
                    <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                      Logout
                    </div>
                  </div>
                }
                onClick={() => {
                  window.localStorage.clear();
                  window.sessionStorage.clear();
                  window.location.href = "/";
                }}
                classname="w-[100%] sm:w-[40%] mx-auto mt-[20px] lg:mt-[40px]"
                style={{ backgroundColor: "#F04438" }}
              />
            </div>
          </div>
        }
      />
      <Modal
        open={openSupport}
        handleClose={handleCloseSupport}
        content={
          <div className="max-w-[570px] p-[20px] sm:px-[60px] sm:py-[40px] flex flex-col items-center justify-center">
            <div className="text-[20px] leading-[28px] sm:text-[31px] sm:leading-[31px] font-semibold font-poppins">
              Need Assistance?
            </div>
            <div className="text-[10px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-medium text-text-color-3 text-center pt-[16px] font-poppins">
              Fill out the form below, and we’ll get back to you as soon as
              possible.
            </div>
            <form onSubmit={formik.handleSubmit} className="w-[100%]">
              <div className="w-[100%] mt-[40px] grid gap-4">
                <TextInput
                  name="name"
                  value={formik.values.name}
                  disabled
                  onChange={(e: any) => {
                    const value = e.target.value;
                    const regex = /^[A-Za-z.\s]*$/; // Allows alphabets, spaces, and periods
                    if (value === "" || regex.test(value)) {
                      formik.setFieldValue("name", value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  inputProps={{
                    placeholder: "Enter your name",
                    maxLength: 40,
                  }}
                />
                <TextInput
                  name="email"
                  type="email"
                  fullWidth
                  disabled
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  inputProps={{ placeholder: "Enter your email" }}
                />
                <TextInput
                  name="phoneNumber"
                  fullWidth
                  disabled
                  value={formik.values.phoneNumber}
                  onChange={(e: any) => {
                    const value = e.target.value;
                    const regex = /^[0-9]*$/;
                    if (value === "" || regex.test(value)) {
                      formik.setFieldValue("phoneNumber", value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.phoneNumber &&
                    Boolean(formik.errors.phoneNumber)
                  }
                  helperText={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }
                  inputProps={{
                    placeholder: "Enter you phone number",
                    maxLength: 10,
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment
                          style={{
                            borderRight: "1px solid #070C1A33",
                            margin: "0",
                            paddingRight: "8px",
                          }}
                          position="start"
                        >
                          +91
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <TextInput
                  name="query"
                  fullWidth
                  value={formik.values.query}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.query && Boolean(formik.errors.query)}
                  helperText={formik.touched.query && formik.errors.query}
                  inputProps={{ placeholder: "Write your query..." }}
                  row={2}
                  multiline={true}
                  sx={{
                    div: {
                      padding: 0,
                    },
                  }}
                />
              </div>
              {/* <div>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={siteKey}
                  onChange={(value: any) =>
                    formik.setFieldValue("captchaResponse", value)
                  }
                  className="my-[10px]"
                />
                {formik.touched.email && Boolean(formik.errors.email) && (
                  <div className="text-text-color-8 text-[0.75rem] leading-[1.66] mx-[14px]">
                    {formik.touched.captchaResponse &&
                      formik.errors.captchaResponse}
                  </div>
                )}
              </div> */}
              <div className="block sm:flex items-center justify-between w-[100%]">
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] text-text-color-3">
                        Cancel
                      </div>
                    </div>
                  }
                  onClick={handleCloseSupport}
                  classname="w-[100%] sm:w-[40%] mx-auto mt-[20px] lg:mt-[40px]"
                  style={{ backgroundColor: "#E5E5E5" }}
                />
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                        Submit
                      </div>
                    </div>
                  }
                  type="submit"
                  classname="w-[100%] sm:w-[40%] mx-auto mt-[20px] lg:mt-[40px]"
                />
              </div>
            </form>
            <div className="text-center mt-[30px] text-[14px] leading-[18px] font-semibold">
              <a
                href="mailto:care@coversure.in"
                style={{
                  cursor: "pointer",
                }}
              >
                support@coversure.in
              </a>{" "}
              |{" "}
              <a
                href="tel:02238431000"
                style={{
                  cursor: "pointer",
                }}
              >
                022-38431000
              </a>
            </div>
          </div>
        }
      />
      <Modal
        open={openTerm}
        handleClose={handleCloseTerm}
        content={
          <div className="max-w-[550px] p-[20px] sm:py-[40px] sm:px-[30px] flex flex-col items-center">
            <div className="flex items-center justify-between w-[100%]">
              <div className="text-[18px] leading-[20px] sm:text-[31px] sm:leading-[31px] font-semibold font-poppins ">
                Terms and Conditions
              </div>
              <div>
                <img
                  src={CloseImg}
                  alt="CloseImg"
                  onClick={handleCloseTerm}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 pt-[16px] font-poppins">
              Welcome to coversure prosure. Please read these Terms and
              Conditions carefully before using our services. By accessing or
              using our website, mobile application, or services, you agree to
              comply with and be bound by the following terms.
            </div>
            <div className="w-[100%] text-[12px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-semibold mt-[30px] mb-[10px]">
              1. General Terms
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 font-poppins">
              Welcome to coversure prosure. Please read these Terms and
              Conditions carefully before using our services. By accessing or
              using our website, mobile application, or services, you agree to
              comply with and be bound by the following terms.
            </div>
            <div className="w-[100%] text-[12px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-semibold mt-[20px] mb-[10px]">
              2. Eligibility
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 font-poppins">
              Welcome to coversure prosure. Please read these Terms and
              Conditions carefully before using our services. By accessing or
              using our website, mobile application, or services, you agree to
              comply with and be bound by the following terms.
            </div>
            <div className="w-[100%] text-[12px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-semibold mt-[20px] mb-[10px]">
              3. Policy Terms
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 font-poppins">
              3.1 The specific terms of your insurance policy, including
              coverage, premium, and exclusions, will be detailed in your policy
              document. These terms will take precedence over any general
              descriptions on our website or promotional materials.
            </div>
            <br />
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 font-poppins">
              3.2 It is your responsibility to review and understand your policy
              document. If you have any questions, please contact our support
              team.
            </div>
            <div className="w-[100%] text-[12px] leading-[16px] sm:text-[18px] sm:leading-[27px] font-semibold mt-[20px] mb-[10px]">
              4. Premium Payments
            </div>
            <div className="text-[12px] leading-[16px] sm:text-[16px] sm:leading-[24px] text-text-color-3 font-poppins">
              4.1 Premiums must be paid in full by the due date specified in
              your policy. Failure to pay premiums on time may result in policy
              cancellation.
            </div>
          </div>
        }
      />
      <VideoModal isOpen={isOpen} close={handleChange} videoUrl={link} />
    </div>
  );
};

export default DashboardLayout;
